// import Button from '~/components/common/button';
import Container from '~/components/common/container';

interface TopSectionProps {
   title?: string;
   firstpargraph: string;
   secondpargraph: string;
   thirdpargraph: string;
   fourthpargraph?: string;
   fifthpargraph?: string;
   // button: string;
   img: string;
}

const TopSection = ({
   title,
   firstpargraph,
   secondpargraph,
   thirdpargraph,
   fourthpargraph,
   fifthpargraph,
   // button,
   img,
}: TopSectionProps) => {
   return (
      <Container>
         <div className="lg:grid lg:grid-cols-2 gap-4 flex flex-col text-xl">
            <div>
               <div className="text-4xl font-bold">{title}</div>
               <div className="py-10 ">
                  <div className="pb-5">{firstpargraph}</div>
                  <div className="pb-5">{secondpargraph}</div>
                  <div className="pb-5">{thirdpargraph}</div>
                  <div className="pb-5">{fourthpargraph}</div>
                  <div className="pb-5">{fifthpargraph}</div>

                  {/* <div className="pt-5">
                     <a href="#business-form">
                        <Button className="text-white py-4 px-2 xs:px-6 focus:outline-none">
                           {button}
                        </Button>
                     </a>
                  </div> */}
               </div>
            </div>
            <div className="pt-10">
               <img src={img} />
            </div>
         </div>
      </Container>
   );
};

export default TopSection;
